import { render, staticRenderFns } from "./head1.vue?vue&type=template&id=0b8817eb&scoped=true&"
import script from "./head1.vue?vue&type=script&lang=js&"
export * from "./head1.vue?vue&type=script&lang=js&"
import style0 from "./head1.vue?vue&type=style&index=0&id=0b8817eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8817eb",
  null
  
)

export default component.exports